import { icache } from '@dojo/framework/core/middleware/icache';
import { create, v, w } from '@dojo/framework/core/vdom';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { theme } from '@dojo/widgets/middleware/theme';
import { SlidingPane } from '@holmescorp/base-widgets';
import { createNlsMiddleware } from '@holmescorp/lcc-state';
import { css } from '../css/drawer.m.css';
import slidingPaneCss from '../css/sliding-pane.m.css';
import TableOfContents from './toc';
const factory = create({
    icache,
    nls: createNlsMiddleware('ditabook'),
    theme
}).properties();
export const TocDrawer = factory(({ id: widgetId, properties, middleware: { icache, nls, theme } }) => {
    const { isPlaceholder, messages } = nls();
    if (isPlaceholder) {
        return null;
    }
    const { key = 'toc', onClose, open = false } = properties();
    const vw = window.innerWidth || 0;
    const themeCss = theme.classes(css);
    return v('div', { xqa: 'toc-sliding-pane', widgetId, classes: [themeCss.root] }, [
        w(SlidingPane, {
            key,
            ...formatAriaProperties({ label: messages.toc_title }),
            theme: theme.compose(slidingPaneCss, css, 'nav_drawer'),
            open,
            align: 'left',
            underlay: true,
            width: Math.min(vw, 1024),
            title: messages.toc_title,
            onRequestClose: () => {
                icache.set('open', false);
                onClose && onClose();
            }
        }, [w(TableOfContents, { onClose })])
    ]);
});
export default TocDrawer;
